import { daDK } from '@mui/x-data-grid/locales';

import { DataGridPremium } from '@mui/x-data-grid-premium';
import EnergyXplorerToolbar from './PortfolioAnalysisToolbar';

export default function PortfolioAnalysisManagementDatagrid(props) {
  const {
    initialRows = [],
    isLoading = true,
    setSelectedRow = () => {},
  } = props;
  const initialState = {
    sorting: {
      sortModel: [
        {
          field: 'Name',
          sort: 'desc',
        },
      ],
    },
  };

  const columns = [
    {
      field: 'AccountId',
    },
    {
      field: 'Name',
    },
    {
      field: 'power',
    },
    {
      field: 'power_in_sync',
    },
    {
      field: 'water',
    },
    {
      field: 'water_in_sync',
    },
    {
      field: 'heat',
    },
    {
      field: 'heat_in_sync',
    },
    {
      field: 'default_daytime_start',
    },
    {
      field: 'default_daytime_end',
    },
    {
      field: 'new',
    },
    {
      field: 'demo_account',
    },
    {
      field: 'integrated',
    },
    {
      field: 'hasService',
    },
  ].map((column) => {
    return { ...column, flex: 1 };
  });

  return (
    <DataGridPremium
      localeText={daDK.components.MuiDataGrid.defaultProps.localeText}
      rows={initialRows}
      columns={columns}
      initialState={initialState}
      loading={isLoading}
      defaultGroupingExpansionDepth={-1}
      slots={{
        toolbar: EnergyXplorerToolbar,
      }}
      slotProps={{
        loadingOverlay: {
          variant: 'linear-progress',
          noRowsVariant: 'skeleton',
        },
      }}
      onRowClick={(params) => {
        setSelectedRow(params.row);
      }}
      sx={{
        '.MuiDataGrid-aggregationColumnHeaderLabel': {
          display: 'none',
        },
        '& .cell-left-border': {
          borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
        },
        '& .left-margin-cell': {
          paddingLeft: 7,
        },
        '& .autogenerated': {
          fontWeight: 'bold',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          whiteSpace: 'break-spaces',
          lineHeight: 1.5,
          fontWeight: 'bold',
        },
        '& .MuiDataGrid-columnHeaderTitleContainerContent': {
          height: '100%',
        },
        '& .MuiDataGrid-aggregationColumnHeader': {
          height: '100%',
        },
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer':
          {
            pl: 1,
          },
        border: 'none',
        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
          {
            outline: 'none',
          },
        '& .MuiDatagrid-root': {
          border: 0,
        },
        '.MuiDataGrid-withBorderColor': {
          border: 'none !important',
        },
        '& .MuiDatagrid-footerContainer': {
          border: 0,
        },
        '& .MuiDatagrid-bottomContainer': {
          border: 0,
        },
        '& .MuiDataGrid-main': {
          backgroundColor: (theme) =>
            theme.palette.mode === 'light' ? '#fff' : '#121212',
          borderRadius: 2,
          border: (theme) => `1px solid ${theme.palette.divider}`,
        },
        '& .MuiDataGrid-columnHeaders': {
          borderBottom: '1px solid',
          borderColor: 'divider',
        },
        '& .MuiDataGrid-columnsContainer': {
          backgroundColor: 'blue',
        },
        '& .selected-row': {
          backgroundColor: (theme) => theme.palette.action.selected,
          '&:hover': {
            backgroundColor: (theme) => theme.palette.action.selected,
          },
        },
      }}
    />
  );
}
